const disable_on_submit_buttons = document.querySelectorAll('button[type="submit"]');

if (disable_on_submit_buttons) {
  disable_on_submit_buttons.forEach(function(button) {
      button.closest('form').addEventListener('submit', function() { return button.disabled = true });
  });
}
